export default "__VITE_ASSET__BOuddEaT__"